export enum ClaimContextType {
  ListingGroup = 1,
  Event = 2
}
